import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {LOCALE_CONFIG, Logger} from '@common-lib';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmPopupComponent} from '../../components/';
import {ConfigurationService, ProductSettingsService} from '../../pages-services';

@Component({
    selector: 'app-settings-product-settings',
    templateUrl: './settings-product-settings.component.html',
    styleUrls: ['./settings-product-settings.component.scss']
})
export class SettingsProductSettingsComponent implements OnInit {

    editModalRef: BsModalRef;
    selectedRow: {
        id: number,
        key: string,
        value: string,
        product: {
            id: number,
            name: string
        },
        new: boolean
    };
    searchTerm = '';

    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        {key: 'key', title: 'Key'},
        {key: 'value', title: 'Value'},
        {key: 'actions', title: 'Actions'}
    ];
    data = [];
    rows = [];
    selected = new Set();
    originalRowForEdit: any = null;

    products;
    selectedProduct;


    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(
        private route: ActivatedRoute,
        private productSettingsService: ProductSettingsService,
        private configurationService: ConfigurationService,
        private translate: TranslateService,
        private toasterService: ToasterService,
        private modalService: BsModalService,
        private logger: Logger
    ) {
    }

    ngOnInit() {
        this.configurationService.getList('products', LOCALE_CONFIG.DEFAULT_LOCALE).subscribe(({result: {products}}) => {
            this.products = products;
            this.selectedProduct = this.products[0].id;
            this.getList();
        });
    }

    getList() {
        this.productSettingsService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    eventEmitted($event) {
        switch ($event.event) {
            case 'onSelectAll':
                this.data.forEach((val, key) => {
                    if (this.selected.has(key)) {
                        this.selected.delete(key);
                    } else {
                        this.selected.add(key);
                    }
                });
                break;
            case 'onDoubleClick':
                this.editRow($event.value.row);
                break;
        }
    }

    showEditForm(template: TemplateRef<any>) {
        this.editModalRef = this.modalService.show(template);
    }

    editRow(row) {
        this.selectedRow = row;
        this.selectedRow = this.originalRowForEdit = Object.assign({}, row);
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    toggleRow({target: {checked}}, row) {
        const index = this.data.indexOf(row);
        if (checked) {
            this.selected.add(index);
        } else {
            this.selected.delete(index);
        }
    }

    isRowSelected(row) {
        return this.selected.has(this.data.indexOf(row));
    }

    saveProductSetting() {
        this.editModalRef.hide();
        this.productSettingsService.update(
            this.selectedProduct,
            this.selectedRow.key,
            this.selectedRow.value
        ).subscribe(async (result) => {
            this.getList();
            const successMessage = await this.translate.get('webpanel.product_settings.save.success_message').toPromise();
            this.toasterService.pop('success', '', successMessage);
        });
    }

    search() {
        this.rows = this.data.filter((r) => r.product.id === this.selectedProduct && r.key && r.value && (this.searchTerm.length === 0 ||
            r.key.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            r.value.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1));
        return this.rows;
    }

    addNew() {
        this.selectedRow = {
            id: 0,
            key: '',
            value: '',
            product: {id: 0, name: ''},
            new: true
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeItem(item) {
        this.selectedRow = item;
        if (this.selectedRow) {
            this.confirmPopup.show();
        }
    }

    confirm(res) {
        if (res) {
            if (this.selectedRow) {
                this.productSettingsService.delete(this.selectedRow).subscribe(async (resp) => {
                    this.selectedRow = null;
                    const successMessage = await this.translate.get('webpanel.product_settings.delete.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                    this.getList();
                });
            }
        } else {
            this.selectedRow = this.originalRowForEdit;
            this.originalRowForEdit = null;
        }
    }

    decline() {
        this.selectedRow = this.originalRowForEdit;
        this.originalRowForEdit = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings-product-settings/settings-product-settings.component.ts